module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "preface_page"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "chaptertitle"
  }, [_vm._v("PREFACE")]), _vm._v(" "), _c('p', {
    staticClass: "extra-indent",
    attrs: {
      "id": "prf1_p1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "extra-indent",
    attrs: {
      "id": "prf1_p1c"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "prf1_p1a"
    }
  }, [_vm._v("The substance of this volume consists of two series of lectures. The first was given at Westminster College, Fulton, Missouri, in May 1949, under the auspices of the John Findley Green Foundation. The second was given in January 1951 at Northwestern University under the auspices of the Shaffer Lectureship. Both lectureships dealt with the position of our nation in the present world situation, as interpreted from the standpoint of the Christian faith. The Westminster and Northwestern lectures are embodied in "), _c('span', {
    attrs: {
      "href": "#/chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapters II")]), _vm._v(" to "), _c('span', {
    attrs: {
      "href": "#/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "prf1_p2"
    }
  }, [_vm._v("The first and the last chapters, in which I seek to explain the framework of “irony” within which I have sought to interpret American history, make explicit, what was only implicit in my original lectures. Since, however, I have postponed a full exposition of the concept of “irony” as it is used in these pages to the last chapter it may be appropriate to anticipate some of the explanations of that chapter in this brief introduction.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "prf1_p3"
    }
  }, [_vm._v("We frequently speak of “tragic” aspects of contemporary history; and also call attention to a “pathetic” element in our present historical situation. My effort to distinguish “ironic” elements in our history from tragic and pathetic ones, does not imply the denial of tragic and pathetic aspects in our contemporary experience. It does rest upon the conviction that the ironic elements are more revealing. The three elements might be distinguished as follows: (a) Pathos is that element in an historic situation which elicits pity, but neither deserves admiration nor warrants contrition. Pathos arises from fortuitous cross-purposes and confusions in life for which no reason can be given, or guilt ascribed. Suffering caused by purely natural evil is the clearest instance of the purely pathetic. (b) The tragic element in a human situation is constituted of conscious choices of evil for the sake of good. If men or nations do evil in a good cause; if they cover themselves with guilt in order to fulfill some high responsibility; or if they sacrifice some high value for the sake of a higher or equal one they make a tragic choice. Thus the necessity of using the threat of atomic destruction as an instrument for the preservation of peace is a tragic element in our contemporary situation. Tragedy elicits admiration as well as pity because it combines nobility with"), _c('a', {
    attrs: {
      "id": "page_XXiv"
    }
  }), _vm._v(" guilt. (c) Irony consists of apparently fortuitous incongruities in life which are discovered, upon closer examination, to be not merely fortuitous. Incongruity as such is merely comic. It elicits laughter. This element of comedy is never completely eliminated from irony. But irony is something more than comedy. A comic situation is proved to be an ironic one if a hidden relation is discovered in the incongruity. If virtue becomes vice through some hidden defect in the virtue; if strength becomes weakness because of the vanity to which strength may prompt the mighty man or nation; if security is transmuted into insecurity because too much reliance is placed upon it; if wisdom becomes folly because it does not know its own limits—in all such cases the situation is ironic. The ironic situation is distinguished from a pathetic one by the fact that the person involved in it bears some responsibility for it. It is differentiated from tragedy by the fact that the responsibility is related to an unconscious weakness rather than to a conscious resolution. While a pathetic or a tragic situation is not dissolved when a person becomes conscious of his involvement in it, an ironic situation must dissolve, if men or nations are made aware of their complicity in it. Such awareness involves some realization of the hidden vanity or pretension by which comedy is turned into irony. This realization either must lead to an abatement of the pretension, which means contrition; or it leads to a desperate accentuation of the vanities to the point where irony turns into pure evil.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "prf1_p4"
    }
  }, [_vm._v("Our modern liberal culture, of which American civilization is such an unalloyed exemplar, is involved in many ironic refutations of its original pretensions of virtue, wisdom, and power. Insofar as communism has already elaborated some of these pretensions into noxious forms of tyranny, we are involved in the double irony of confronting evils which were distilled from illusions, not generically different from our own. Insofar as communism tries to cover the ironic contrast between its original dreams of justice and virtue and its present realities by more and more desperate efforts to prove its tyranny to be “democracy” and its imperialism to be the achievement of universal peace, it has already dissolved irony into pure evil.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "prf1_p5"
    }
  }, [_vm._v("Whether these concepts are fruitful principles for the interpretation of current history must be left to the reader to judge, after perusing the chapters of this volume. I must add that I"), _c('a', {
    attrs: {
      "id": "page_xxv"
    }
  }), _vm._v(" have no expert competence in the field of American history; and I apologize in advance to the specialists in this field for what are undoubtedly many errors of fact and judgment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "prf1_p6"
    }
  }, [_vm._v("I express my gratitude to the Presidents and the committees of Westminster College and Northwestern University for many courtesies during my visits to these institutions. I am also deeply grateful to my wife, Professor Ursula Niebuhr, to Professor Edmond Cherbonnier of Barnard College, for careful reading of my manuscript and for many suggestions for its improvement and to Professor Arthur Schlesinger, Jr., of Harvard who read most of the chapters and suggested important amendments. Naturally, none of my critics must be held responsible for defects in my basic thesis or in its detailed elaboration.")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-right",
    attrs: {
      "id": "prf1_p7"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EINHOLD")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IEBUHR")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-right",
    attrs: {
      "id": "prf1_p8"
    }
  }, [_vm._v("New York City")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-right",
    attrs: {
      "id": "prf1_p9"
    }
  }, [_vm._v("January, 1952")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be64193c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/prf1.vue
// module id = 72
// module chunks = 0